// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".animate-text{opacity:0}.animate-text_word-wrapper{display:inline-block;vertical-align:top;overflow:hidden;white-space:pre-wrap;margin-top:-.125em;margin-bottom:-.125em;padding-top:.125em;padding-bottom:.125em}.animate-text_word{display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
